import React from "react";
import { ajaxWrapper, getGlobalState } from "functions";
import { Button, TextInput, FormWithChildren, EmptyModal, Link, Container } from "library";

import ModalFancyCharSheet from "pages/monsters/fancy_char_sheet/modal_version.js";
import load_dnd_constants from "pages/session_tools/global_data/load_dnd_constants.js";

export default class EditMonster extends React.Component {
	constructor(props) {
		super(props);

		let params = getGlobalState()["params"];

		this.state = {
			loaded: false,
			id: params["id"],
			modal_content: null,
		};

		this.refresh_monster = this.refresh_monster.bind(this);
		this.monster_callback = this.monster_callback.bind(this);
		this.redirect_to_monster = this.redirect_to_monster.bind(this);
	}

	componentDidMount() {
		if (this.state.id) {
			load_dnd_constants(this.refresh_monster);
		} else {
			this.setState({ loaded: true });
		}
	}

	refresh_monster() {
		ajaxWrapper(
			"GET",
			"/api/compendium/monster/" + this.state.id + "/?related=action_spells,monster_resources,magical_attributes",
			{},
			this.monster_callback,
		);
	}

	monster_callback(result) {
		var monster = result[0].monster;
		console.log("Monster", monster);

		this.setState({
			monster: monster,
			loaded: true,
		});
	}

	redirect_to_monster(result) {
		var id = result[0].monster.id;
		window.location = "/edit_monster/" + id + "/";
	}

	render() {
		var submitUrl = "/api/compendium/monster/";
		var delete_button = null;

		if (!this.state.id) {
			return (
				<div className="container">
					<div className="card-container row">
						<div className="card col-12">
							<Link href="/dm_tools/monster_list/" text="<- Monster List" />
						</div>

						<div className="col-12 card">
							<h1>{"Create Monster:"}</h1>
							<FormWithChildren
								submitUrl={"/api/compendium/monster/"}
								setGlobalState={this.setGlobalState}
								autoSetGlobalState={true}
								globalStateName={"form"}
								redirect={this.redirect_to_monster}
							>
								<TextInput name="name" label="Name" />
							</FormWithChildren>
						</div>
					</div>
				</div>
			);
		} else {
			submitUrl = "/api/compendium/monster/" + this.state.id + "/";
			delete_button = (
				<Button
					type="danger"
					text="Delete Monster"
					dangerType={true}
					href={"/api/compendium/monster/" + this.state.id + "/delete/"}
				/>
			);
		}

		var content = null;
		if (this.state.loaded) {
			content = (
				<div className="container">
					<div className="card-container row">
						<div className="card col-12">
							<Link href="/dm_tools/monster_list/" text="<- Monster List" />
						</div>

						<div className="col-12 card">
							<ModalFancyCharSheet
								monster_id={this.state.id}
								push_modal_content={(value) => this.setState({ modal_content: value })}
								dm_view={true}
							/>
						</div>

						<div className="card col-12">
							<div>{delete_button}</div>
						</div>
					</div>
				</div>
			);
		}

		return (
			<div>
				{content}
				<br />
				<br />

				{this.state.modal_content ? (
					<EmptyModal show={true} onHide={() => this.setState({ modal_content: null })}>
						<Container>
							<div>{this.state.modal_content}</div>
						</Container>
					</EmptyModal>
				) : null}
			</div>
		);
	}
}
